import { render, staticRenderFns } from "./ViberTemplate.vue?vue&type=template&id=29ca32e6&"
import script from "./ViberTemplate.vue?vue&type=script&lang=ts&"
export * from "./ViberTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ViberTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports